__turbopack_context__.v({
  "offerSentWrapper": "_2ujx4G_offerSentWrapper",
  "offerSentWrapperTop": "_2ujx4G_offerSentWrapperTop",
});
